import React from 'react';

export default function WelcomeScreen({ onStart }) {
  return (
    <div className="welcome-screen">
      <button className="btn-primary" onClick={onStart}>
        Начать новую баню
      </button>
    </div>
  );
}
